import { render, staticRenderFns } from "./editNote.vue?vue&type=template&id=71f86009&lang=pug"
import script from "./editNote.vue?vue&type=script&lang=js"
export * from "./editNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports